import React from "react";
import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  return (
    <div className="p-8 text-center">
    <div className="max-w-md mx-auto">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Access Restricted
      </h2>
      <p className="text-gray-600">
        You don't have the required permissions to view this Page. Please contact your administrator for access.
      </p>
    </div>
  </div>
  );
};

export default UnauthorizedPage;